import {
  Dispatch,
  Key,
  MouseEvent as ReactMouseEvent,
  SetStateAction,
  useEffect,
  useLayoutEffect,
  useState
} from 'react'

import {
  Grid,
  GridCellProps,
  GridColumn,
  GridPageChangeEvent,
} from '@progress/kendo-react-grid'

import { Button, DropDownButton } from '@progress/kendo-react-buttons'
import { PagerTargetEvent } from '@progress/kendo-react-data-tools'
import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from '@progress/kendo-react-layout'
import { format } from 'date-fns'
import { CSVLink } from 'react-csv'
import SessionStorageService from '../../services/SessionStorageService'
import { GetUserNameTecnico, TiposUtilizacao, b64toBlob, estadosTitulo, exportPDFWithMethod, get, handleDownload, hasPermission, post, setusoSoloSelected, tipoDeProcesso, tipoTitulos, updateColumnsGrid } from '../../services/utils'
import { useUsoDoSoloStore } from '../../stores/usoDoSolo'
import styles from '../../styles/usodosolo/ResultadoUsoDoSoloForm.module.scss'
import commonStyles from '../../styles/common/Common.module.scss'
import { CONSULTAR_US_TITULO, CURRENT_TIMEZONE, GET_DOCUMENTO, GET_DOCUMENTO_BY_US_TITULO, GET_LIST_RESULTS_TITULO, GET_US_TITULO_BY_ID, GET_US_TITULO_SHAPEFILE, LAYER_INDEX_US_TITULO, OPERATIONAL_LAYER, PERMISSION_USOSOLO_PERFIL_COMPLETO_EDICAO, PERMISSION_USOSOLO_PERFIL_COMPLETO_LEITURA, PERMISSION_USOSOLO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_USOSOLO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_USOSOLO_PERFIL_TOTAL, PESQUISAR_ENTIDADEBYUSER, RECORDS_LIMIT, RELATORIO_MERGE_TITULO, URL_AJUDA_USOS_SOLO_TITULO, US_TITULOS_POINT_NAME, clearLayers } from '../../utils/constants'
import { ResultadoTituloUsoDoSoloCommandGridCell } from './ResultadoTituloUsoDoSoloCommandGridCell'
import clsx from 'clsx'
import { useCommonStore } from '../../stores/common'
import MaximizeButton from '../common/MaximizeButton'
import useClearMap from '../../hooks/useClearMap'
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { process } from '@progress/kendo-data-query'
import { GridPDFExport, PDFExport } from '@progress/kendo-react-pdf'
import { ResultadoDocumentoCommandGridCell } from '../documentos/ResultadoDocumentoCommandGridCell'
import { Dialog } from '@progress/kendo-react-dialogs'
import ImagePreviewV2 from '../viewer/ImagePreviewV2'
import VisualizadorColunas from '../Generico/VisualizadorColunas '
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais'
import ReactGA from 'react-ga4';
import moment from 'moment'
import "moment-timezone"
import { base64ApaImage, base64FooterImages, base64SiarlImage } from '../../routes/Base64Images'

type IProps = {
  onCloseClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
  setShowResults: Dispatch<SetStateAction<boolean>>
  setShowRegistarUsoDoSoloForm?: Dispatch<SetStateAction<boolean>>
}

type PageState = {
  skip: number
  take: number
}

const initialDataState: PageState = { skip: 0, take: 20 }

type TituloUsoDoSolo = {
  id: number;
  designacao: string;
  id_processo: string;
  utilizador_id: number;
  utilizador?: any;
  data_registo: string;
  data_entrada_vigor: string;
  data_expiracao: string;
  data_alteracao_licenciamento: string;
  freguesia_cod?: any;
  nuts3_cod?: any;
  geom_imported?: any;
  codigo_processo: string;
  codigo_utilizacao: string;
  categoria?: any;
  tipo_processo_id?: any;
  tipo_utilizacao_id?: any;
  observacoes: string;
  geom?: any;
  dataEmissao: string;
  urlTitulo: string;
}

const keyPainelPrincipal:Key = 'tituloUsoSoloColunasVisiveis';
const keyPainelDocumentos:Key = 'tituloUsoSoloDocumentosColunasVisiveis';
export default function ResultadoUsoDoSoloForm({
  onCloseClick,
  setShowRegistarUsoDoSoloForm,
  setShowResults
}: IProps) {
  const [isMobile, setIsMobile] = useState(false);
  const [selected, setSelected] = useState<number>(0)
  const [showExportButtons, setShowExportButtons] = useState(true)

  const [tituloUsoDoSolo, setTituloUsoDoSolo] = useState<any[]>([])
  const [documentosUsTitulo, setDocumentosUsTitulo] = useState([])

  const [page, setPage] = useState<PageState>(initialDataState)
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >()
  
   const getDocumento = async (data: any) =>
  await get<any, any>(`${GET_DOCUMENTO}/` + data)

   
  const getEntidadeByUser = async (data: any) => await get<any, any>(`${PESQUISAR_ENTIDADEBYUSER}/` + data)

  const isCurrentViewMaximized = useCommonStore(state => state.isCurrentViewMaximized)

  const REGISTOS = 0;
  const DOCUMENTOS = 1;
  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected)
    if (e.selected == REGISTOS) {
      setShowExportButtons(true)
    } else if (e.selected == DOCUMENTOS) {
      setShowExportButtons(false)
    }
  }
  const handlePageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent
    const take = event.page.take

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value)
    }

    setPage({
      ...event.page,
      take,
    })
  }
  
   const [dataStateDocumentos, setDataStateDocumentos] = useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });
  
  const dataStateChangeDocumentos = (event: any) => {
    setDataResultDocumentos(process(documentosUsTitulo, event.dataState));
    setDataStateDocumentos(event.dataState);
  };

  const [dataResultDocumentos, setDataResultDocumentos] = useState(
    process(documentosUsTitulo, dataStateDocumentos)
  );
  
  const getUsoDoSolo = async (data: any) =>
    await get<any, any>(`${GET_US_TITULO_BY_ID}/` + data)

    const getDocumentosByUsTituloIDs = async (data: any) =>
  await post<any, any>(`${GET_DOCUMENTO_BY_US_TITULO}` , data)

  const getShapeFile = async (data: any) =>
  await post<any, any>(`${GET_US_TITULO_SHAPEFILE}`, data)

  const getTituloPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_TITULO}`, data)

   const [urlDoDocumento, setUrlDoDocumento] = useState("");
  const [idDoDocumento, setIdDoDocumento] = useState("");
  const [openForm, setOpenForm] = useState<boolean>(false)
  
    const documentosToPreview = documentosUsTitulo;

    const [clearMap] = useClearMap();
  const clearSearchResults = () => {

    clearMap(clearLayers["CLEAR_LAYERS_US_TITULO"]);
    SessionStorageService.removeItem('resultadoUsoDoSoloPesquisa')
    sessionStorage.removeItem('lastSearchTitulo')
    postMessage({ type: 'resultadoUsoDoSoloPesquisaChange' }, '*')

    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
        { type: clearLayers["CLEAR_LAYERS_US_TITULO"], value: 'true' },
        '*'
    )
  }
  const selectUsoDoSoloResultId = useUsoDoSoloStore(
    (state) => state.selectUsoDoSoloResultId
  )
  const selectUsoDoSoloResult = useUsoDoSoloStore(
    (state) => state.selectUsoDoSoloResult
  )

  const consultarTitulo = async (data: any) =>
  await post<any, any>(`${CONSULTAR_US_TITULO}`, data)

  const relatorioTituloMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE_TITULO}`, data)

  useEffect(() => {
    if (sessionStorage.getItem("lastSearchTitulo") && !SessionStorageService.getItem("firstCallUsTitulo")) {
      postMessage({ type: "showLoader" }, "*");
      const objToSearch = sessionStorage.getItem("lastSearchTitulo") ?? '';
      consultarTitulo(objToSearch).then((data) => {
        SessionStorageService.setItem("resultadoUsoDoSoloPesquisa", data);
        setResultsTitulo();
        postMessage({ type: "hideLoader" }, "*");
      })
    } 
    else {
      setResultsTitulo();
  }
  
  }, []);

  const setResultsTitulo= () => {    
    
    let titulosUsoDoSolo = 
      SessionStorageService.getItem('resultadoUsoDoSoloPesquisa') 
    
    
    if (titulosUsoDoSolo) {
      // Ajuste das datas aqui
      titulosUsoDoSolo = titulosUsoDoSolo.map((tituloUsoDoSolo: any) => ({
        ...tituloUsoDoSolo,
          data_entrada_vigor: tituloUsoDoSolo.data_entrada_vigor ? moment.utc(tituloUsoDoSolo.data_entrada_vigor).tz(CURRENT_TIMEZONE).format("DD/MM/yyyy") : '',
          data_expiracao: tituloUsoDoSolo.data_expiracao ? moment.utc(tituloUsoDoSolo.data_expiracao).tz(CURRENT_TIMEZONE).format("DD/MM/yyyy") : '',
          data_registo: tituloUsoDoSolo.data_registo ? moment.utc(tituloUsoDoSolo.data_registo).tz(CURRENT_TIMEZONE).format("DD/MM/yyyy HH:mm:ss") : '',
          data_emissao: tituloUsoDoSolo.data_emissao ? moment.utc(tituloUsoDoSolo.data_emissao).tz(CURRENT_TIMEZONE).format("DD/MM/yyyy HH:mm:ss") : '',
          data_alteracao_licenciamento: tituloUsoDoSolo.data_alteracao_licenciamento ? moment.utc(tituloUsoDoSolo.data_alteracao_licenciamento).tz(CURRENT_TIMEZONE).format("DD/MM/yyyy HH:mm:ss") : '',

      }));
    }

    if (titulosUsoDoSolo) {
      const iframe: any = document.getElementById('iframeGeoPortal')
      const ids: number[] = []
      const idsApoio: number[] = []
      titulosUsoDoSolo.forEach((element: any) => {
        ids.push(element.id)
      })

      iframe.contentWindow?.postMessage(
        { type: 'SiarlDefineExtraLayerTooltipColumns', value:
          { layer: US_TITULOS_POINT_NAME,  columns: columns.columns.filter((x: { show: any }) => x.show).map((option: { field: any; title: any }) => ({
       field: option.field,
       title: option.title
     })) } },
        '*'
      )

      iframe.contentWindow?.postMessage(
        { type: 'SiarlUsTituloSearch', value:{ ids : ids, result:titulosUsoDoSolo } },

        '*'
      )
    }

    const ids = titulosUsoDoSolo?.map((x: any) =>x.id);

    setTituloUsoDoSolo(titulosUsoDoSolo)
     getDocumentosByUsTituloIDs(ids).then(result => {
        setDocumentosUsTitulo(result);
        postMessage({ type: "hideLoader" }, "*");
      })
      
  }

  useEffect(() => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    const ids: number[] = []
    tituloUsoDoSolo.forEach((element: any) => {
      ids.push(element.id)
    })
    iframe.contentWindow?.postMessage(
      { type: 'SiarlUsTituloSearch', value: ids },
      '*'
    )
  },[])


   const documentCustomCell = (props: GridCellProps) => (
    <ResultadoDocumentoCommandGridCell
    onLocationMouseEnter={function (documentos: Record<string, unknown>): void {
      console.log("n/a");
    } } onLocationMouseLeave={function (documentos: Record<string, unknown>): void {
      console.log("n/a");
    } } {...props}
    onInfoClick={handleInfoClickById}
    onLocationClick={handleLocationClick}
    onDocumentPreviewClick={handleDocumentPreviewClickById}    />
  )

   const nextPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const nextIds = documentosToPreview
        .filter((doc: any) => doc.id < idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (nextIds.length > 0) {
        const nextId = Math.max(...nextIds);
        console.log(`O próximo ID é ${nextId}`);
  
        const documento = await getDocumento(nextId);
  
        setIdDoDocumento(nextId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        const id = documento.entidade_id ?? documento.id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlEntidadesCenter',
            value: [id],
          },
          '*'
        )
  
      } else {
        console.log("Não há um próximo ID na lista.");
      }

    }catch(error){

      postMessage({ type: "errorMsg", value: "Não foi possivel abrir o documento!" }, "*");

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
   
  }

  const previousPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const previousIds = documentosToPreview
        .filter((doc: any) => doc.id > idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (previousIds.length > 0) {
        const previousId = Math.min(...previousIds);
        console.log(`O anterior ID é ${previousId}`);
  
        const documento = await getDocumento(previousId);
  
        setIdDoDocumento(previousId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        const id = documento.entidade_id ?? documento.id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlEntidadesCenter',
            value: [id],
          },
          '*'
        )
      } else {
        console.log("Não há um anterior ID na lista.");
      }

    }catch(error){

      postMessage({ type: "errorMsg", value: "Não foi possivel abrir o documento!" }, "*");

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
       
  }

  const openPdfNewTab = () => {
    return new Promise<void>((resolve, reject) => {
        
        postMessage({ type: "showLoader" }, "*");

        setTimeout(() => {
           const columnsToShow = columnsGrid.columns.filter((x: { show: any }) => x.show);
           const dataToExport = tituloUsoDoSolo?.map((item: any) => {
            const filteredItem: any = {};
            columnsToShow.forEach((column: any) => {
                if (column.field.indexOf(".") != -1) {
                  const textArr = column.field.split(".");
                  const fieldString = textArr[0];
                  const valueString = textArr[1];
                  if (valueString && item[fieldString] && item[fieldString][valueString]) {
                    filteredItem[column.field] = item[fieldString][valueString];
                  }
                } else {
                filteredItem[column.field] = item[column.field];
              }
            });
            return filteredItem;
            });
            
            exportPDFWithMethod(columnsToShow, dataToExport, 4)
                .then((pdfData: any) => {
                    postMessage({ type: "hideLoader" }, "*");

                        const base64Data = pdfData.split(";base64,")[1];
                        console.log(base64Data);
                        const blob = b64toBlob(base64Data, 'application/pdf');
                        const blobUrl = URL.createObjectURL(blob);

                      
                        window.open(blobUrl, '_blank');
                        resolve();
                  
                })
                .catch((error: any) => {
                    console.error('Error exporting PDF:', error);
                    reject(error);
                });
        }, 1000);
    });
};

   const handleDocumentPreviewClickById = (documentosLocal: Record<string, any>) => async () => {

    try {
      
      postMessage({ type: "showLoader" }, "*");
      const documentos = await getDocumento(documentosLocal.id);

      setIdDoDocumento(documentosLocal.id);
      setUrlDoDocumento(documentos.url);
      setOpenForm(true);

    } catch (error) {

      postMessage({ type: "errorMsg", value: "Não foi possivel abrir o documento!" }, "*");
      setOpenForm(false);

    } finally {

      postMessage({ type: "hideLoader" }, "*");

    }
  }

  const close = () => {
  setOpenForm(false);
}

useEffect(() => {
  ReactGA.send({ hitType: "pageview", page: "/ResultadoUsosDoSoloTitulo" });
}, []);

  const handleInfoClickById = (tituloUsoDoSoloLine: any) => async () => {

     const id = tituloUsoDoSoloLine.us_titulo_id ?? tituloUsoDoSoloLine.id;
     const tituloUsoDoSolo = await getUsoDoSolo(id);

     if (!tituloUsoDoSolo) {
      postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
      return;
    }
    const tecnico = await GetUserNameTecnico(tituloUsoDoSolo.utilizador_id);
    
    selectUsoDoSoloResultId(tituloUsoDoSolo.id)
    const usosSoloObject = {
      ...tituloUsoDoSolo,
      titulo: tituloUsoDoSolo?.titulo ?? undefined,
      id: tituloUsoDoSolo?.id ?? undefined,
      idProcesso: tituloUsoDoSolo?.id_processo ?? undefined,
      data_entrada_vigor: tituloUsoDoSolo.data_entrada_vigor ? moment.utc(tituloUsoDoSolo.data_entrada_vigor).tz(CURRENT_TIMEZONE) : undefined,
      data_expiracao: tituloUsoDoSolo.data_expiracao ? moment.utc(tituloUsoDoSolo.data_expiracao).tz(CURRENT_TIMEZONE) : undefined,
      data_alteracao_licenciamento: tituloUsoDoSolo.data_alteracao_licenciamento ? moment.utc(tituloUsoDoSolo.data_alteracao_licenciamento).tz(CURRENT_TIMEZONE) : undefined,
      data_emissao: tituloUsoDoSolo.data_emissao ? moment.utc(tituloUsoDoSolo.data_emissao).tz(CURRENT_TIMEZONE) : undefined,
      designacao: tituloUsoDoSolo?.designacao ?? undefined,
      freguesia: tituloUsoDoSolo?.freguesia ?? undefined,
      massaagua : tituloUsoDoSolo?.massaagua ?? undefined,
      praia: tituloUsoDoSolo?.praia ?? undefined,
      tecnicoRegisto: tecnico,
      data_registo: tituloUsoDoSolo.data_registo ? moment.utc(tituloUsoDoSolo.data_registo).tz(CURRENT_TIMEZONE) : undefined,
      designacaoIdentificacao: tituloUsoDoSolo?.designacao ?? undefined,
      tipoDeProcesso: tituloUsoDoSolo?.tipo_processo_id && tipoDeProcesso ? tipoDeProcesso.find(x => x.id == tituloUsoDoSolo?.tipo_processo_id) : undefined,
      codProcesso: tituloUsoDoSolo?.codigo_processo ?? undefined,
      tipoUtilizacao: tituloUsoDoSolo?.tipo_utilizacao_id ? TiposUtilizacao.find(x => x.id == tituloUsoDoSolo?.tipo_utilizacao_id) : undefined,
      codUtilizacao: tituloUsoDoSolo?.codigo_utilizacao ?? undefined,
      categoria: tituloUsoDoSolo?.categoria ?? undefined,
      nifRequerente: tituloUsoDoSolo?.nif_requerente ?? undefined,
      nomeRequerente: tituloUsoDoSolo?.nome_requerente ?? undefined,
      obs: tituloUsoDoSolo?.observacoes ?? undefined,
      filedoc_cod: tituloUsoDoSolo?.filedoc_cod ?? undefined,
      estado_id: tituloUsoDoSolo?.estado ?? undefined,
      tipo_registo: tituloUsoDoSolo?.tipo_registo ?? undefined,
      urlTitulo: tituloUsoDoSolo?.url_titulo ?? undefined,
      tipoTitulo: tituloUsoDoSolo?.tipo_titulo_id ? tipoTitulos.find (x => x.id == tituloUsoDoSolo?.tipo_titulo_id) : undefined,
      urlProcesso: tituloUsoDoSolo?.url_processo ?? undefined

    }
    sessionStorage.setItem('usGeomEdited', 'false')

    selectUsoDoSoloResult(usosSoloObject);
    setusoSoloSelected(usosSoloObject);
    setShowResults(false)
    SessionStorageService.setItem("novoUsTitulo", 'false');
    if (setShowRegistarUsoDoSoloForm) setShowRegistarUsoDoSoloForm(true)

    const iframe: any = document.getElementById('iframeGeoPortal')

    iframe.contentWindow?.postMessage({ type: "SiarlUsTituloSearch", value: [tituloUsoDoSolo?.id] }, '*')

    iframe.contentWindow?.postMessage({ type: "SiarlUsTituloCenter", value: [tituloUsoDoSolo?.id] }, '*')

  }

  const handleLocationClick = (usTitulo: Record<string, unknown>) => async () => {
    console.log(`#${usTitulo.id} - mostrar popover no mapa`)
    const iframe: any = document.getElementById('iframeGeoPortal')
    //iframe.contentWindow?.postMessage({ type: "SiarlOcorrenciasSearch", value: [ocorrencia.id] }, '*')
    if (usTitulo.id) {
      iframe.contentWindow?.postMessage(
        {
          type: 'SiarlUsTituloCenter',
          value: [usTitulo.id],
        },
        '*'
      )
    }
  }

  const conditionalProps = hasPermission(PERMISSION_USOSOLO_PERFIL_TOTAL) || hasPermission(PERMISSION_USOSOLO_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_USOSOLO_PERFIL_COMPLETO_LEITURA) || hasPermission(PERMISSION_USOSOLO_PERFIL_INTERMEDIO_EDICAO) || hasPermission(PERMISSION_USOSOLO_PERFIL_INTERMEDIO_LEITURA) ?
  { 
    onInfoClick: handleInfoClickById,
    onLocationClick: handleLocationClick
  } 
  : {};

  const CommandCell = (props: GridCellProps) => (
    <ResultadoTituloUsoDoSoloCommandGridCell
      {...props}
      {...conditionalProps}
    />
  )

  const onItemClick = (event: any) => {

    const link: HTMLAnchorElement | null = document.querySelector('#print-results');

    if (link) {
      link.click();
    }

    // if (event.item.key == 'ExportarFichasResultados') {

      

    // } else if (event.item.key == 'ExportarListaResultados') {

    //   console.log(event.item.text);

    // }

  };

  const onItemClickExportarFichasTitulo = async () => {
    try {
  
    
      const relatorios = [];
  
      const results = SessionStorageService.getItem('resultadoUsoDoSoloPesquisa');
  
      const idsUs = results.map((o: any) => o.id);
  
      if(idsUs.length  > RECORDS_LIMIT){
        postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fíchas" } }, '*')
        return false
        }
    
  
      const titulos = await getTituloPorIds(idsUs);
      
      
        postMessage({ type: 'showLoader' }, '*');
      
        for (const tituloId of idsUs) {
  
        const titulo = titulos.find((titulo: any) => titulo.id === tituloId);
        const ResultEntidade = await getEntidadeByUser(titulo?.utilizador?.id)

        const objToSendImgMapa : any = {
          CodPrintTemplate: "RELATORIO_US_TITULO",
          extendInfo: {
            spatialReference: {
              wkid: 0
            },
            xmin: 0,
            ymin: 0,
            xmax: 0,
            ymax: 0
          },
          ListOperationalLayerInfo: [
            {
              IdOperationLayer: OPERATIONAL_LAYER,
              UseLayerExtent: false,
              DefinitionExpression: "",
              ListServiceLayer: [
                {
                    LayerId: LAYER_INDEX_US_TITULO,
                    DefinitionExpression: "id=" + titulo?.id,
                    UseLayerExtent: true
                }
              ]
            }
          ]
        }
  
        let origem : any;
        if(titulo?.tipo_registo == 1){
        origem = "CMs, Capitanias - Registo Manual"
        }
        else if(titulo?.tipo_registo == 2){
          origem = "APA - Registo do SILIAMB"
        }
  
  
     
        const relatorio = {
          Id: titulo?.id,
          dados: {
            'REGISTO' : '',
            'Nº processo APA:': titulo?.filedoc_cod ?? '',
            'Estado:': titulo?.estado?.alias_descricao ?? '',
            'Data/hora registo:' : titulo?.data_registo ? new Date(titulo?.data_registo).toLocaleDateString() : new Date(titulo?.dataHoraRegisto).toLocaleDateString(),
            'Técnico:' : titulo?.utilizador?.name ?? '' ,
            'Entidade:' : ResultEntidade?.nome ?? '',
            'Origem do registo:' : origem ?? '',
  
  
            'IDENTIFICAÇÃO' : '',
            'Designação:' : titulo?.designacao ?? '',
            'ID do processo:': titulo?.id_processo ?? '',
            'Data entrada em vigor:': titulo?.data_entrada_vigor ? new Date(titulo?.data_entrada_vigor).toLocaleDateString() : '',
            'Data de expiração:': titulo?.data_expiracao ? new Date(titulo?.data_expiracao).toLocaleDateString() : '',
            'Data de emissão:': titulo?.data_emissao? new Date(titulo?.data_emissao).toLocaleDateString() : '',
            'Data de alteração:': titulo?.data_alteracao_licenciamento? new Date(titulo?.data_alteracao_licenciamento).toLocaleDateString() : '',
            'Nome do requerente:' : titulo?.nome_requerente ?? '',
            'Nif requerente:': titulo?.nif_requerente ?? '',
            'Código do processo:': titulo?.codigo_processo ?? '',
            'Url do processo:': titulo?.url_processo ?? '',
            'Código utilização:' : titulo?.codigo_utilizacao ?? '',
            'Url título:': titulo?.url_titulo ?? '',
  
             //Localização
             'LOCALIZAÇÃO' : '',
             'Concelho:': titulo?.concelho?.nome ?? '',
             'ARH :': titulo?.arh?.nome ?? '',
             'Capitania:': titulo?.capitania?.nome ?? '',
             'Praia:': titulo?.praia?.nome ?? '',
            //  'Referência de local:': titulo?.ref_localizacao ?? '',
  
             'TIPOLOGIA' : '',
             'Tipo de título:' : titulo?.tipoTitulo?.descricao ?? '',
             'Tipo de processo:' : titulo?.tipoProcesso?.nome ?? '',
             'Tipo de utilização:' : titulo?.tipoUtilizacao?.nome ?? '',
             'Categoria:' : titulo?.categoria ?? '',
  
             'OBSERVAÇÕES' : '',
             'Observação:': titulo?.observacoes ?? '',
  
          },      
          img_mapa: "",
          objJsonToCreateImg: objToSendImgMapa
  
        };      
        relatorios.push(relatorio);
    }
  
    const mergedPdfBase64 = await relatorioTituloMerge(relatorios);
    if (mergedPdfBase64) {
      const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    }
  } catch (error) {
    console.log(error);
    postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
  } finally {
    postMessage({ type: 'hideLoader' }, '*');
  }
  }; 

  const options = [
    {
      key: 'ExportarFichasResultados',
      text: 'Fichas',
    },
    {
      key: 'ExportarListaResultados',
      text: 'Resultados',
    },
 
  ]

  const itemRender = (props: { item: any; itemIndex: number }) => {
    const isTitleItem = props.item.key === 'titulo';
    if (isTitleItem) {
      // Item de título personalizado
      return (
        <div className={styles.DropDownButtonTitulo}>
          <span>{props.item.text}</span>
        </div>
      );
    } else {
      // Demais itens
      return (
        <div className={styles.DropDownButtonItem}>
          <span>{props.item.text}</span>
        </div>
      );
    }
  };

  const [dataState, setDataState] = useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });
  const dataStateChange = (event: any) => {
    setDataResult(process(tituloUsoDoSolo, event.dataState));
    setDataState(event.dataState);
  };

  const [dataResult, setDataResult] = useState(
    process(tituloUsoDoSolo, dataState)
  );

  const optionsExportar = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'Excel',
    },
    // {
    //   key: 'ExportarListaResultadosPdf',
    //   text: 'PDF',
    // },
    {
      key: 'ExportarListaResultadosShapeFile',
      text: 'Shapefile',
    },
    {
      key: 'ExportarTodasFichas',
      text: 'Fichas',

    }
  ]
  
  let _pdfExport: any;
  const exportExcel = () => {
    _export.save();
  };

  const PageTemplate = (props: any) => (
    <div className="page-template">
       <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px', padding: '10px' }}>
      
       <div>
       <img style={{ width: '128px', height: 'auto', marginLeft: '2px' }} src={base64SiarlImage} alt="SIARL Logo" />
       </div>
       <div style={{ textAlign: 'right' }}>
         <span style={{ fontSize: '18px', color: '#1ba49c' }}>PESQUISA DE USOS DO SOLO</span>
       </div>
     </div>
     <div className="footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px' }}>
        
       <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
         <img style={{ width: '105px', marginBottom: '-25px' }} src={base64ApaImage} alt="APA Logo" />
         <img style={{ width: '280px', height: 'auto', marginBottom: '-25px' }} src={base64FooterImages} alt="Footer Image" />
       </div>
      
       <div style={{ flex: 1, textAlign: 'right', marginBottom: '-25px' }}>
        Data : {format(new Date(), "dd/MM/yyyy")} | Página {props.pageNum} de {props.totalPages}
       </div>
     </div>
   </div>
 );

  const onItemClickExportar = async (event: any) => {
    if (event.item.key == 'ExportarListaResultadosExcel') {
      exportExcel();
    }
    else if (event.item.key == "ExportarListaResultadosShapeFile") {
      const results = 
        SessionStorageService.getItem('resultadoUsoDoSoloPesquisa') 
      
  
      if (results) {
        const iframe: any = document.getElementById('iframeGeoPortal')
        const ids: number[] = []
        results.forEach((element: any) => {
          ids.push(element.id)
        })

        const file: any = await getShapeFile(ids);
        const filePath = 'shapeFileUsTitulos.zip';

        handleDownload(file, filePath);
    } 
  }
  if(event.item.key == "ExportarTodasFichas"){
    onItemClickExportarFichasTitulo();
  }

  if(event.item.key == "ExportarListaResultadosPdf"){
    exportPDF();
  }
}

  let _export: any;
  const exportPDF = () => {
    _pdfExport.save();
  };

  const onItemClickImprimir = async (event: any) => {
    openPdfNewTab();
  }

  const [columsDocuments, setColumsDocuments] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean }[] }>({
    columns: [
      { field: "id", width: 70, title: "ID", show: true },
      { field: "us_titulo_id", title: "ID título", show: true ,width: 120},
      { field: "dataPublicacaoFormatted", width: 150, title: "Data publicação", show: true },
      { field: "tipoRecurso.designacao", width: 150, title: "Tipo de recurso", show: true },
      { field: "titulo", width: 150, title: "Título", show: true },
      { field: "autores", width: 150, title: "Autor", show: true },
      { field: "entidade.nome", width: 150, title: "Entidade", show: true },
      { field: "primarioDescription", width: 180, title: "Primário", show: true },
    ]
  })

  const [columsInicio, setColumsInicio]=useState<{columns:{field:string, title:string, width:number|string, show:boolean}[]}>({
    columns:[
      { field: "id", title: "ID", show: true, width: 70 },
      { field: "estado.alias_descricao", title: "Estado", show: true, width: "150" }, 
      { field: "designacao", title: "Designação", show: true , width: "180"},
      { field: "id_processo", title: "ID do processo", show: true, width: "150" }, 
      { field: "tipoTitulo.descricao", title: "Tipo de Título", show: true, width: 150 },
      { field: "tipoUtilizacao.nome", title: "Tipo de utilização", show: true, width: 190 },
      { field: "concelho.nome", title: "Concelho",  show: true, width: 270 },  
      { field: "filedoc_cod", title: "Nº Processo APA", show: false, width: "200" }, 
      { field: "utilizador.name", title: "Técnico de registo", show: false, width: "170" }, 
      { field: "data_registo", width: 150, title: "Data registo", show: false },
      { field: "origem", title: "Origem do registo", show: false, width: "170" }, 
      { field: "data_entrada_vigor", title: "Data entrada em vigor", show: false, width: 190 },
      { field: "data_expiracao", title: "Data Expiração", show: false, width: 150 },
      { field: "data_emissao", title: "Data Emissão", show: false, width: 150 },
      { field: "data_alteracao_licenciamento", title: "Data alteração licenciamento", show: false, width: 240 },
      { field: "nome_requerente", title: "Nome requerente", show: false, width: "aut150o" }, 
      { field: "nif_requerente", title: "NIF do requerente", show: false, width: 200 },
      { field: "codigo_processo", title: "Cód. Processo", show: false, width: 150 },
      { field: "url_processo", title: "Url do processo", show: false, width: 150 },
      { field: "codigo_utilizacao", title: "Cód. Utilização", show: false, width: 150 },
      { field: "url_titulo", title: "URL do Título", show: false, width: 150 },
      { field: "nuts1.nome", title: "NUTS I",  show: false, width: 270 },  
      { field: "nuts2.nome", title: "NUTS II",  show: false, width: 270 },  
      { field: "nuts3.nome", title: "NUTS III",  show: false, width: 270 },  
      { field: "distrito.nome", title: "Distrito",  show: false, width: 270 },  
      { field: "freguesia.nome", title: "Freguesia",  show: false, width: 270 },  
      { field: "arh.nome", title: "ARH", show: false, width: 270 },  
      { field: "massaAgua.nome", title: "Massa de água", show: false, width: 270 },  
      { field: "capitania.nome", title: "Capitania", show: false, width: 270 },  
      { field: "praia.nome", title: "Praia", show: false, width: 270 },  
      { field: "tipoProcesso.nome", title: "Tipo de processo", show: false, width: 180 },
    ]
  })

  const columnsOrdered = {columns: columsInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))} 


  const [columns, setColumns] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsUsosSolo');
    return storedValue ?? columnsOrdered;
  });

  const [columnsGrid, setColumnsGrid] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsUsosSoloGrid');
    return storedValue ?? columsInicio;
  }); 


  useEffect(() => {

      const iframe: any = document.getElementById('iframeGeoPortal')
      iframe.contentWindow?.postMessage(
        { type: 'SiarlDefineExtraLayerTooltipColumns', value:{  layer: US_TITULOS_POINT_NAME,  columns: columns.columns.filter((x: { show: any }) => x.show).map((option: { field: any; title: any }) => ({
      field: option.field,
      title: option.title
    })) } },
        '*'
      )
    }, [columns]);

    useEffect(() => {
      SessionStorageService.setItem("columnsUsosSolo", columns)
      updateColumnsGrid(columns, columnsGrid, setColumnsGrid)
    }, [columns])

    useEffect(() => {
      SessionStorageService.setItem("columnsUsosSoloGrid", columnsGrid)
    }, [columnsGrid])
    
  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

    };
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);  


  const onItemClickMais = (event: any) => {

    elementoClickMais(event);
    
    onItemClickExportar(event);


  };

  const optionsMais = [
    {
      key: 'titulo',
      text: 'Imprimir',
    },
    {
      key: 'titulo',
      text: 'Exportar',
    },
    ...optionsExportar.map(option => ({
      ...option,
      className: 'icon-siarl icon-exportar btnIconRegistar',
    })),
  ]

  const registarNovoClick = () => {
    selectUsoDoSoloResultId(undefined);
    selectUsoDoSoloResult(undefined);
    sessionStorage.setItem('usGeomEdited', 'false')
    SessionStorageService.setItem("novoUsTitulo", 'true');
    postMessage({ type: "form", value: "registarUsoDoSolo" }, "*");
  }

  const openAjuda = () => {
    window.open(URL_AJUDA_USOS_SOLO_TITULO, "_blank")
  }

return (
  <div className={clsx(styles.base, isCurrentViewMaximized && commonStyles.maximizedBaseForm)}>
    <div className={styles.header}>
      <div>
        <div className={styles.nomeDoModulo}>Usos de solo</div>
        <div className={styles.tituloDaPagina}>Resultados de pesquisa</div>
      </div>

      <div>

        {hasPermission(PERMISSION_USOSOLO_PERFIL_TOTAL) || hasPermission(PERMISSION_USOSOLO_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_USOSOLO_PERFIL_INTERMEDIO_EDICAO)?
          <Button
            onClick={registarNovoClick}
            className={styles.btnNovoRegisto}
            hidden={selected>0}
            style={{ display: isMobile ? 'none' : '' }}
            id='novoRegisto'
            title='Novo título'
          >
            <span className="icon-siarl icon-registar btnIconRegistar"></span>{' '}
            &nbsp;{' '}
            Novo título
          </Button>
        : ''}
        
        <CSVLink
          title="Imprimir resultados"
          id="print-results"
          data={[]}
          filename={`siarl-usoDoSolo-${format(new Date(), 'ddMMyyyHHmm')}`}
          hidden
        >
        </CSVLink>

        {(!isMobile && showExportButtons) ?
        <VisualizadorColunas 
              columns={columns} 
              setColumns={setColumns}
              styles={styles.btnEditar2} 
           />
        : ''}
        {showExportButtons ? 
        <button className={styles.btnEditar2} onClick={exportPDF} style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
          <span className="icon-siarl icon-imprimir"></span>
        </button>
        : <></>}
        {!isMobile && showExportButtons ?
          <DropDownButton
          items={optionsExportar}
          className={styles.btnImprimir}
          style={{marginTop: '-4px'}}
          iconClass="icon-siarl icon-exportar"
          onItemClick={onItemClickExportar}
          fillMode={'flat'}
          title='Exportar'
          itemRender={itemRender}
        ></DropDownButton>
        : ''}

        {isMobile && showExportButtons ?
          <DropDownButton
            items={optionsMais}
            className={styles.btnMais}
            iconClass="icon-siarl icon-mais"
            onItemClick={onItemClickMais}
            fillMode={'flat'}
            itemRender={itemRenderMais}
            title="Mais Opções"
          />
        : ''}

        <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
          <span className="icon-siarl icon-ajuda"></span>
        </button>

        <button className={styles.btnFechar} onClick={onCloseClick} title="Minimizar">
          <span className="icon-siarl icon-minimizar"></span>
        </button>

        {!isMobile &&
        <MaximizeButton className={styles.btnMaximizar} />
        }
      </div>
    </div>

    <TabStrip selected={selected} onSelect={handleSelect} scrollable={isMobile}>
      <TabStripTab title="Títulos" key={'titulos'}>

      <ExcelExport
        fileName='Resultado_Titulos'
              data={tituloUsoDoSolo.map((usTitulo: any) => ({
                ...usTitulo,
               
              }))}
              ref={(exporter) => {
                _export = exporter
              }}
            >
              <Grid
                className={styles.form}
                sortable={true}
                onDataStateChange={dataStateChange}
                data={
                  dataResult.data.length > 0
                    ? dataResult
                    : tituloUsoDoSolo.slice(page.skip, page.take + page.skip).map((pretensao: any) => ({
                      ...pretensao,
                    
                    }))
                }
                {...dataState}
                pageable={{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: true,
                  previousNext: true,
                }}
                //groupable={true}
                total={tituloUsoDoSolo.length}
              >
                <GridColumn cell={CommandCell} width={100} />
                
          {columnsGrid?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined }, i: Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
              </Grid>
            </ExcelExport>
            
            <GridPDFExport  
              fileName='Resultado_UsoDoSolo'
              ref={(element) => {
                _pdfExport = element
              }}
              paperSize="A4"
              margin={{ top: '3cm', right: '1cm', bottom: '2cm', left: '1cm' }}
              landscape={true}
              pageTemplate={PageTemplate} 
              repeatHeaders={true}
            >
                {
              <Grid
                sortable={true}
                 data={tituloUsoDoSolo}                
                pageable={{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: true,
                  previousNext: true,
                }}
                style={{ borderSpacing: '0' }} 
                //groupable={true}
              >
                {columnsGrid?.columns?.map((column: any, i: any) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} filter={column.filter} width={column.width} title={column.title} columnMenu={column.columnMenu}
                headerCell={() => <div className="pdf-header">{column.title}</div>}
                cell={(props: any) => (
                  <td style={{ fontSize: '10px', wordBreak: 'break-word', padding: '5px', border: '1px solid #1ba49c' , lineHeight: '1.3' }}>
                    {props.dataItem[column.field]}
                  </td>
                )}
                />
              )
            );
          })}
              </Grid>
            }
            </GridPDFExport>
      </TabStripTab>

    <TabStripTab title="Documentos">
        <ExcelExport
          fileName='Resultado_Documentos_Titulos'
          data={documentosUsTitulo}
          ref={(exporter) => {
            _export = exporter
          }}
        >
          <Grid
            className={styles.form}
            sortable={true}
            onDataStateChange={dataStateChangeDocumentos}
            data={
              dataResultDocumentos.data.length > 0
                ? dataResultDocumentos
                : documentosUsTitulo.slice(page.skip, page.take + page.skip)
            }
            {...dataState}
            pageable={{
              buttonCount: 5,
              info: true,
              type: 'numeric',
              pageSizes: true,
              previousNext: true,
            }}
            total={documentosUsTitulo.length}
            //groupable={true}
          >
            <GridColumn cell={documentCustomCell} width={86} />
            {columsDocuments?.columns?.map((column, i) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
          </Grid>
        </ExcelExport>

        <GridPDFExport
          fileName='Resultado_Documentos_UsoDoSolo'
          ref={(element) => {
            _pdfExport = element
          }}
          margin="1cm"
        >
          <Grid
            className={styles.form}
            sortable={true}
            onDataStateChange={dataStateChangeDocumentos}
            data={
              dataResultDocumentos.data.length > 0
                ? dataResultDocumentos
                : documentosUsTitulo
            }
            {...dataState}
            pageable={{
              buttonCount: 5,
              info: true,
              type: 'numeric',
              pageSizes: true,
              previousNext: true,
            }}
            //groupable={true}
          >
            <GridColumn cell={documentCustomCell} width={86} />
            <GridColumn field="id" width={70} title="ID" />
            <GridColumn
              field="filedoc_cod"
              width={190}
              title="ID Documento Filedoc"
            />
            <GridColumn
              field="data_publicacao"
              width={150}
              title="Data publicação"
            />
            <GridColumn
              field="tipoRecurso.designacao"
              width={150}
              title="Tipo de recurso"
            />
            <GridColumn field="titulo" width={90} title="Título" />
            <GridColumn field="autores" width={90} title="Autor" />
            <GridColumn field="entidade.nome" width={300} title="Entidade" />
            <GridColumn field="estado_id" width={'auto'} title="Estado" />
          </Grid>
        </GridPDFExport>
      </TabStripTab>
    </TabStrip>
     {openForm && (
        <Dialog
        className="ModalDocumentos"
          title={`Documento: ${idDoDocumento}`}
          onClose={close}
          style={{ zIndex: 999 }}
        >
  
            <ImagePreviewV2
              documentUrl={urlDoDocumento}
              next={(e: any) => nextPhoto(e)}
              previous={(e: any) => previousPhoto(e)}
            />

        </Dialog>
      )}

    <div
      className={clsx(styles.footer, styles.justify_one_child, isCurrentViewMaximized && commonStyles.maximizedFooter)}
    >
      <Button className={styles.btnPesquisar} onClick={clearSearchResults} title='Nova Pesquisa'>
        <span className="icon-siarl icon-pesquisar"></span>
        <span className={styles.rotulo}>
          {' '}&nbsp;{' '}
          Nova Pesquisa
        </span>
      </Button>
    </div>
  </div>
)

}